import MyRoutes from "./routers";
import React, { useEffect, useMemo, useRef, useState } from "react";

const App = () => {
  useEffect(() => {
    localStorage.setItem('isPopUpLoaded', true);
  }, [])
  return (
    <div className="text-base dark:bg-neutral-900/95 text-neutral-900 dark:text-neutral-200 font-body">
      <MyRoutes />
    </div>
  );
}

export default App;
